import React from 'react';
import PropTypes from 'prop-types';

function UserMessage({ message: { id, avatar, content, date, owner } }) {
  return (
    <div key={`message-${id}`} className={`chat-msg ${owner && 'owner'}`}>
      <div className="chat-msg-profile">
        <img className="chat-msg-img" src={avatar} alt="" />
        <div className="chat-msg-date"> Message send {date}</div>
      </div>
      <div className="chat-msg-content">
        <div className="chat-msg-text">{content}</div>
      </div>
    </div>
  );
}

UserMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    owner: PropTypes.bool.isRequired,
  }).isRequired,
};

export default UserMessage;
